module.exports = __webpack_public_path__ + "img/curve_1.40dd307f.png";